/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import List from './List';
import * as placeholderAction from './store/PlaceHolderManagement.action';
import { months, Year } from '../../../Components/helper';

function PlaceholderManagement() {
  const dispatch = useDispatch();
  const reducer = useSelector((reducerstate) => reducerstate);
  const { UserDetails } = reducer;
  const { userInfo } = UserDetails;
  const loggedInUserId = userInfo.userId;
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState([]);

  const createOptions = async (array) => {
    let dataArray = [];
    if (array?.length) {
      dataArray = await array.map((item, i) => {
        return {
          label: item.name || item,
          value: item._id || item,
        };
      });
    }
    return dataArray;
  };

  const getCategoryOne = async () => {
    let res = [];
    res = await dispatch(
      placeholderAction.fetchCategoryAction({
        accessedFrom: 'masters',
        categoryType: 1,
        loggedInUserId,
      }),
    );
    res = createOptions(res);
    return res;
  };

  const getCategoryTwo = async () => {
    let res = [];
    res = await dispatch(
      placeholderAction.fetchCategoryAction({
        accessedFrom: 'masters',
        categoryType: 2,
        loggedInUserId,
      }),
    );
    res = createOptions(res);
    return res;
  };

  const getBrands = async () => {
    let res = [];
    res = await dispatch(
      placeholderAction.fetchAllBrandAction({
        accessedFrom: 'masters',
        loggedInUserId,
      }),
    );
    res = createOptions(res);
    return res;
  };

  const getSeasons = async () => {
    let res = [];
    res = await dispatch(placeholderAction.fetchAllSeasonsAction({ loggedInUserId }));
    res = createOptions(res);
    return res;
  };

  const getMonth = () => {
    let res = [];
    res = createOptions(months);
    return res;
  };

  const getYears = () => {
    let res = [];
    res = createOptions(Year);
    return res;
  };

  useEffect(() => {
    const init = async () => {
      setIsLoading(true);
      const category1 = await getCategoryOne();
      const category2 = await getCategoryTwo();
      const brands = await getBrands();
      const seasons = await getSeasons();
      const month = getMonth();
      const year = getYears();

      const productDescription = [
        { label: 'prduct desc 1', value: '110' },
        { label: 'prduct desc 2', value: '111' },
      ];
      const newnessType = [
        { label: 'Newness Type 1', value: '1' },
        { label: 'Newness Type 2', value: '2' },
      ];
      const sustainability = [
        { label: 'Sustainability 1', value: '1' },
        { label: 'Sustainability 2', value: '2' },
      ];
      const priceBrand = [
        { label: 'price brand 1', value: '1' },
        { label: 'price brand 2', value: '2' },
      ];

      const dataArr = {
        category1,
        category2,
        productDescription,
        brands,
        seasons,
        month,
        year,
        newnessType,
        sustainability,
        priceBrand,
      };
      if (dataArr) setState([dataArr]);
      setIsLoading(false);
    };

    init();
  }, []);

  return (
    <div
      id="scrollableDiv"
      style={{
        maxHeight: 'calc(100vh - 220px)',
        overflow: 'auto',
        display: 'flex',
      }}
      className="mt-4"
    >
      <List isLoading={isLoading} data={state} />
    </div>
  );
}

export default PlaceholderManagement;
